import type { Lang } from "@/i18n/languages";

const LANGS: Lang[] = ["bg", "en", "de", "gr"];

function normalizePath(path: string): string {
  if (!path) return "/";
  if (!path.startsWith("/")) return `/${path}`;
  return path;
}

/**
 * Builds a language-prefixed URL.
 * Examples:
 *  buildLangPath('bg','/') => '/bg'
 *  buildLangPath('de','/privacy-policy') => '/de/privacy-policy'
 *  buildLangPath('en','/#services') => '/en/#services'
 */
export function buildLangPath(lang: Lang, path: string): string {
  if (!LANGS.includes(lang)) lang = "bg";

  const normalized = normalizePath(path);
  if (normalized === "/") return `/${lang}`;

  return `/${lang}${normalized}`;
}

export function buildLangRoot(lang: Lang): string {
  return `/${lang}`;
}

/**
 * Removes a language prefix from a pathname.
 * Examples:
 *  stripLangPrefix('/bg') => '/'
 *  stripLangPrefix('/bg/implantology') => '/implantology'
 */
export function stripLangPrefix(pathname: string): string {
  if (!pathname) return "/";
  const match = pathname.match(/^\/(bg|en|de|gr)(?=\/|$)/);
  if (!match) return pathname;

  const without = pathname.replace(/^\/(bg|en|de|gr)/, "");
  return without === "" ? "/" : without;
}
